import React, { useState } from 'react';
import {
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import RichTextField from '../../../../../Components/Field/RichTextField';
import OtherRequirementInfo from './OtherRequirementInfo';

interface Step3ShortDescriptionProps extends StepProps {
  otherRequirementInfo: any;
  setOtherRequirementInfo: (any) => void;
}

const Step3ShortDescription: React.FC<Step3ShortDescriptionProps> = ({
  currentStepName,
  onNext,
  onBack,
  onCancel,
  currentData,
  isFirstStep,
  otherRequirementInfo,
  setOtherRequirementInfo,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const [shortDescription, setShortDescription] = useState(currentData.shortDescription || '');

  const handleDescriptionChange = (value: any) => {
    if (value && typeof value === 'object' && 'value' in value) {
      setShortDescription(value.value);
    } else {
      setShortDescription('');
    }
  };

  const handleNext = () => {
    if (shortDescription.trim()) {
      onNext({
        shortDescription: shortDescription.trim(),
      });
    }
  };

  const isValid = shortDescription.trim();

  return (
    <Box style={{ width: '100%' }}>
      <Box
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <Box
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <Box style={{  width: '100%' }}>
            {/* Short Description Field - Rich Text */}
            <Box style={{ marginBottom: theme.spacing(3) }}>
              <RichTextField
                name="shortDescription"
                // label={formatMessage({
                //   id: 'law-portal.manage.requirements.shortDescription',
                //   defaultMessage: 'Short Description',
                // })}
                initialState={shortDescription ? { value: shortDescription } : undefined}
                onChange={handleDescriptionChange}
                errorTexts={[]}
                // required={true}
              />
            </Box>
          </Box>
        </Box>

        <OtherRequirementInfo otherRequirementStepInfo={otherRequirementInfo} currentStepName={currentStepName} onUpdate={setOtherRequirementInfo} />
      </Box>

      <StepButtonBar
        onCancel={onCancel}
        onBack={onBack}
        onNext={handleNext}
        nextLabel="form.next"
        nextDisabled={!isValid}
        formatMessage={formatMessage}
        showBack={true}
      />
    </Box>
  );
};

export default Step3ShortDescription;
